import React, {useCallback, useEffect, useRef, useState} from 'react';
import ReactNotification from 'react-notifications-component';
import Leaflet from "./leaflet/Leaflet";
import TopContent from "./visuals/TopContent";
import BodyHeaderContent from "./visuals/BodyHeaderContent";
import AddressForm from "./forms/AddressForm";
import {DEFAULT_POSITION} from "../helpers/Constants";
import IMapConfig from "../interfaces/IMapConfig";
import IPartner from "../interfaces/IPartner";
import Partners from "./partner/Partners";
import ImageGenerator from "./generator/ImageGenerator";
import {LatLngExpression} from "leaflet";
import './App.scss';

const App: React.FC = () => {
    const defaultMapConfig: IMapConfig = {position: null, polygons: [], zoom: 10, swz: false, dragging: true, partnersLocations: new Map<string, any>(), showPartnersLoc: true};
    const [mapConfig, setMapConfig] = useState<IMapConfig>(defaultMapConfig);
    const [partners, setPartners] = useState<IPartner[]>([]);
    const [mapLoader, setMapLoader] = useState<boolean>(false);
    const lfRef = useRef<HTMLDivElement>(null);

    const mapConfigUpdater = useCallback((position: LatLngExpression) => {
        const newMapConfig: IMapConfig = {...mapConfig};
        newMapConfig.position = position;

        setMapConfig({...newMapConfig});
    }, [mapConfig]);

    useEffect(() => {
        if (null === mapConfig.position || undefined === mapConfig.position) {
            if ('geolocation' in navigator) {
                navigator.geolocation.getCurrentPosition(function (geoLocPosition) {
                    mapConfigUpdater([geoLocPosition.coords.latitude, geoLocPosition.coords.longitude]);
                });
            } else {
                mapConfigUpdater(DEFAULT_POSITION);
            }
        }

    }, [mapConfig.position, mapConfigUpdater]);

    return (
        <>
            <ReactNotification/>
            <TopContent title={"Création d'une carte"}/>
            <div className="mainContentContainer">
                <div className="bodyContainer">
                    <BodyHeaderContent title={"Rechercher des agences membres Interkab"}/>
                    <div className="bodyContent">
                        <div className="bodyFormContent">
                            <AddressForm
                                mapConfig={mapConfig}
                                setMapConfig={setMapConfig}
                                partners={partners}
                                setPartners={setPartners}
                                setMapLoader={setMapLoader}
                            />
                        </div>
                        <div className="bodyMapContent">
                            <div className="leafletContent">
                                <label className="labelDefault">Carte</label>
                                <Leaflet
                                    mapConfig={mapConfig}
                                    setMapConfig={setMapConfig}
                                    partners={partners}
                                    setPartners={setPartners}
                                    loader={mapLoader}
                                    lfRef={lfRef}
                                />
                            </div>
                            <div className="partnerContent">
                                <Partners mapConfig={mapConfig}
                                          setMapConfig={setMapConfig}
                                          partners={partners}
                                />
                                <ImageGenerator lfRef={lfRef}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default App;
